import React from 'react';

import { EMessageDirection, EMessageType, IOutcommingTextInput, useMessages } from '../../../hooks/Messages';
import { useMessageContext } from '../Message/MessageContext';

interface IQueryProps {
    alt: string
    children: any
}

function Query({ alt, children }: IQueryProps) {
    const { push } = useMessages();
    const { messageContext, setMessageContext } = useMessageContext();

    if (messageContext.queryTagDisabled) return <>{children}</>;

    return (
        <span
            className='text-link'
            onClick={(e) => {
                setMessageContext({ ...messageContext, queryTagDisabled: true })
                push({
                    direction: EMessageDirection.Outcomming,
                    type: EMessageType.TextInput,
                    payload: {
                        text: alt
                    } as IOutcommingTextInput
                });
            }}>
            {children}
        </span>
    );
}

export default Query;
